module.exports = __webpack_public_path__ + "static/media/midday.a9589a5a.svg";